import * as React from 'react';
import cx from 'classnames';

import { disableScroll, enableScroll } from '@common/utils/scroll';

import './hint.styles.scss';

export type HintProps = React.PropsWithChildren<{
	className?: string;
	description: React.ReactNode;
}>;

export const Hint: React.FC<HintProps> = (props) => {
	const { children = '?', className, description } = props;

	const [opened, setOpened] = React.useState(false);
	const [cords, setCoords] = React.useState<{ top: number; left: number } | undefined>();

	const descriptionRef = React.useRef<HTMLDivElement>();

	const open = React.useCallback(() => {
		setOpened(true);
	}, []);

	const handleOpen = React.useCallback((e: React.MouseEvent) => {
		e.persist();

		open();
		setCoords({
			top: e.clientY,
			left: e.clientX,
		});
		disableScroll();
	}, []);

	const close = React.useCallback(() => {
		setOpened(false);
		enableScroll();
	}, []);

	return (
		<>
			{opened && <div className="Hint__backdrop" onClick={close} />}
			{description && (
				<div 
					ref={descriptionRef as unknown as React.LegacyRef<HTMLDivElement>} 
					className={cx('Hint__description', { 'Hint__description__opened': opened })}
					style={{
						top: cords && descriptionRef.current 
							? cords?.top - descriptionRef.current?.clientHeight - 30
							: undefined,
						left: cords?.left,
					}}
				>
					{description}
				</div>
			)}
			<span className={cx('Hint', { 'Hint--disabled': !description }, className)} onClick={description ? handleOpen : undefined}>{children}</span>
		</>
	);
};